import React, {useState, useRef, useEffect} from 'react';
import styled from 'styled-components'
import {Tabs, Tab} from 'react-bootstrap'
import UsersAdministration from './UserManager/UsersAdministration'
import UserGroupAdministration from './UserGroupManager/UserGroupsAdministration'
import PerspectiveAdministration from './PerspectiveManager/PerspectiveAdministration'
import CustomGroupAdministration from './CustomGroupManager/CustomGroupAdministration'
import CreateCompanyModal from './CreateCompanyModal';

const CompanyContent = ({company, onEdit, showEditCompany}) => {

    return(
        <Content>
            <AssetHeader company={company} onEdit={onEdit} showEditCompany={showEditCompany}/>
            <AssetControler company={company}/>
        </Content>
    )

}

export default CompanyContent;

const Content = styled.div`s
    display:flex;
    height: 100%;
    align-content:flex-start;
    flex-flow:row wrap;

    width: calc(100% - 300px);


`

const AssetHeader = ({company, onEdit, showEditCompany}) => {

    const AssetTitle = styled.div`
        
        width:100%;
        padding: 0 0 0 23px;
        align-items: center;
        border-bottom:1px solid rgb(221, 222, 225);
        background-color:#fff;
        display: flex;
        min-height: 45px;
        
        span{
            font-size:20px;
        }

        .asset-header-edit{
            flex: 1;
            border-left: 1px solid #eee;
            padding-left: 10px;
            margin: 0 10px 0 15px;

            a{
                font-size: 14px;
            }
        }


    `

    return(
        <AssetTitle>
            <span>{company?.name}</span>

            {
                showEditCompany && company?.name && 
                <div className="asset-header-edit">
                    <a onClick={() => onEdit(company)}>
                        <i class="far fa-edit" />
                    </a>
                </div>
            }
        </AssetTitle>
    )

    

}


const AssetControler = (props) => {
    const [height, setHeight] = useState(0)
    const [tab, setTab] = useState('users');
    const ref = useRef(null)

    useEffect(() => {
        setHeight(ref.current.clientHeight)
    })
    

    const MultiTabs = styled.div`
        width:100%;
        height:100%;
        font-size:12px;
        font-style:inherit;


        ul{
            background-color:#eeeeee;
        }


        .tabs-div{
            height:100%;
            
        }

        .tab-content{ 
            /* TabComponent */
            height:${props=> props.tabsHeight-85+"px"} 
            
            
        }
    `

    return(
        <MultiTabs tabsHeight={height}>
          
            <div ref={ref} className="tabs-div">
            {props.company.id ?
            <Tabs
            activeKey={tab}
            onSelect={(k) => {setTab(k)}}>
            {/* <Tab eventKey="company" title="Company" >
              <span><WIP height={height}/></span>
            </Tab> */}
            <Tab  eventKey="users" title="Users">
              <UsersAdministration height={height} company={props.company}/>
            </Tab>
            <Tab  eventKey="users_group" title="Users Group">
              <UserGroupAdministration height={height} company={props.company}/>
            </Tab>
            <Tab eventKey="perspectives" title="Perspectives">
              <PerspectiveAdministration height={height} company={props.company}/>
            </Tab>
            <Tab eventKey="custom_group" title="Custom Group">
                <CustomGroupAdministration height={height} company={props.company}/>
            </Tab>
            </Tabs>
            :
            <div>

            </div>
            
          }

            </div>
        </MultiTabs>
    )


    

}